import React, { useEffect, useState } from 'react';
import { StyleSheet, View } from 'react-native';
import { connect } from 'react-redux';

import i18n from 'i18n-js';

import { isWeb, moderateScale, navigateTo } from '@helpers';
import { createAccount } from '@reducers/user';
import { logOnboarding } from '@reducers/onBoarding';
import ColorsWrapper from '@styles/colors';

import Button from '@components/button/index';
import useStatusBar from '@components/common/useStatusBar';
import Input from '@components/input/index';
import Logo from '@components/logo/index';
import TablerWrapper from '@components/auntification/tablerWrapper';
import {
  AUTH_LOGO_MARGIN_TOP_SMALL,
  AUTH_LOGO_MAX_WIDTH,
  AUTH_LOGO_OFFSET_FORM,
  AUTH_OFFSET_FORM_LARGE,
} from '../tablerWrapper/constants';

const SCENARIO = {
  LOGIN: 'login',
  PROSPECT: 'prospect',
  ON_BOARDING: 'onBoarding',
};

const CreateAccount = ({ createAccount, route, C, logOnboarding, onBoarding }) => {
  const { email, scenario } = route.params;
  const isOnBoarding = scenario === SCENARIO.ON_BOARDING;

  const [company, setCompany] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [loading, setLoading] = useState(false);

  useStatusBar({ C });

  useEffect(() => {
    if (isOnBoarding && !onBoarding?.code) {
      navigateTo('ConnectorSetup');
    }
  }, []);

  const submit = async () => {
    const data = { companyName: company, firstName, lastName, email };

    switch (scenario) {
      case SCENARIO.LOGIN: {
        setLoading(true);
        await createAccount(data, () => navigateTo('DownloadConnector', data));
        setLoading(false);
        return;
      }
      case SCENARIO.PROSPECT: {
        setLoading(true);
        await createAccount(data, () => navigateTo('DownloadConnector'));
        setLoading(false);
        return;
      }
      case SCENARIO.ON_BOARDING: {
        logOnboarding('Component: Enter account details. Action: Next', {
          ...data,
          component: 'Enter account details',
          action: 'Next',
        });
        navigateTo('FactoryTime', { data, scenario: SCENARIO.ON_BOARDING });
        return;
      }
    }
  };

  const isSubmitDisabled = !company || !firstName || !lastName;

  return (
    <TablerWrapper offset={AUTH_OFFSET_FORM_LARGE} keyboardAvoid>
      <Logo
        title={i18n.t('Which data belongs to this account?')}
        small
        marginTop={AUTH_LOGO_MARGIN_TOP_SMALL}
        maxWidth={AUTH_LOGO_MAX_WIDTH}
        offset={AUTH_LOGO_OFFSET_FORM}
        isBack
      />
      <View style={styles.inputContainer}>
        <Input
          placeholder={i18n.t('Company name')}
          onChangeText={setCompany}
          value={company}
          autoCapitalize="sentences"
        />
        <Input
          placeholder={i18n.t('First name')}
          onChangeText={setFirstName}
          value={firstName}
          autoCapitalize="sentences"
        />
        <Input
          placeholder={i18n.t('Last name')}
          onChangeText={setLastName}
          value={lastName}
          autoCapitalize="sentences"
        />
        <Button
          name={i18n.t(isOnBoarding ? 'Next' : 'Ready')}
          disabled={isSubmitDisabled}
          onPress={submit}
          loading={loading}
        />
      </View>
    </TablerWrapper>
  );
};

export default connect(({ onBoarding }) => ({ onBoarding }), {
  createAccount,
  logOnboarding,
})(ColorsWrapper(CreateAccount));

const INPUT_CONTAINER_HEIGHT = 334;
const INPUT_CONTAINER_TOP_MARGIN = 21;
const INPUT_CONTAINER_PHONE_WIDTH = '90%';

const styles = StyleSheet.create({
  inputContainer: {
    width: isWeb ? '100%' : INPUT_CONTAINER_PHONE_WIDTH,
    justifyContent: 'space-between',
    height: moderateScale(INPUT_CONTAINER_HEIGHT),
    marginTop: moderateScale(INPUT_CONTAINER_TOP_MARGIN),
  },
});
